<template>
  <div>
    <hrms-staappr   :staappr='detail.staappr'
                    :nowLang="nowLang"
                    :currentDtereq="setDateOutput(currentDtereq)"
                    :currentNumseq="currentNumseq"
                    :currentCodempid="currentCodempid" />

    <div class="box-func">
      <div class="box-topic border-color-skin">
        <i class="fa fa-envelope margin-r-5 color-skin"></i>
        <label class="color-skin">{{ descCodapp }}</label>
      </div>

      <div class="box-body">
        <div class="row">
          <form role="form">
            <div class="col-lg-1"></div>
            <div class="col-xs-12 col-md-6 col-lg-5">
              <div class="row">
                <!--   O.T Period   -->
                <div class="col-xs-12">
                    <h4 class="page-header">{{ labels['HRES6KEC2']['20'] }} <span class="red">*</span></h4>
                    <div class="row">
                        <!--   From Date  -->
                        <div class="col-xs-6 col-ms-6 col-sm-6">
                            <div class="form-group clearfix">
                                <label>{{ labels['HRES6KEC2']['30'] }} <span class="red">*</span></label>
                                <hrms-datepicker  v-model="detail.dtestrt"
                                                  :disabled="!validateStaappr"
                                                  v-validate="'required|date_format:DD/MM/YYYY|before:dteend'"
                                                  data-vv-value-path="inputDate"
                                                  name="dtestrt"
                                                  :has-error="errors.has('dtestrt')" />
                                <div class="text-error" v-show="errors.has('dtestrt')">{{errors.first('dtestrt')}}</div>
                            </div>
                        </div>

                        <!--   To Date  -->
                        <div class="col-xs-6 col-ms-6 col-sm-6">
                            <div class="form-group clearfix">
                                <label>{{ labels['HRES6KEC2']['40'] }} <span class="red">*</span></label>
                                <hrms-datepicker  v-model="detail.dteend"
                                                  :disabled="!validateStaappr"
                                                  v-validate="'required|date_format:DD/MM/YYYY|after:dtestrt'"
                                                  data-vv-value-path="inputDate"
                                                  name="dteend"
                                                  :has-error="errors.has('dteend')" />
                                <div class="text-error" v-show="errors.has('dteend')">{{errors.first('dteend')}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--   O.T Time   -->
                <div class="col-xs-12">
                    <h4 class="page-header">{{ labels['HRES6KEC2']['50'] }} <span class="red">*</span></h4>
                    <div class="row">
                        <!--   Before Time Work  -->
                        <div class="col-md-12">
                            <div class="form-group clearfix">
                                <div class="row">
                                    <div class="col-xs-6">
                                        <label>{{ labels['HRES6KEC2']['60'] }}</label>
                                        <hrms-timepicker  v-model="detail.timbstr"
                                                          :disabled="!validateStaappr"
                                                          v-validate="'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timbend|date_format:HH:mm'"
                                                          data-vv-value-path="inputTime"
                                                          name="timbstr"
                                                          :has-error="errors.has('timbstr')" />
                                        <div class="text-error" v-show="errors.has('timbstr')">{{errors.first('timbstr')}}</div>
                                    </div>

                                    <div class="col-xs-6">
                                        <label>&nbsp;</label>
                                        <span class="pull-left" style="margin-top:30px; margin-left:-15px; ">-</span>
                                        <hrms-timepicker  v-model="detail.timbend"
                                                          :disabled="!validateStaappr"
                                                          v-validate="'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timbstr|date_format:HH:mm'"
                                                          data-vv-value-path="inputTime"
                                                          name="timbend"
                                                          :has-error="errors.has('timbend')" />
                                        <div class="text-error" v-show="errors.has('timbend')">{{errors.first('timbend')}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--   Holiday Time Work   -->
                        <div class="col-md-12">
                            <div class="form-group clearfix">
                                <div class="row">
                                    <div class="col-xs-6">
                                        <label>{{ labels['HRES6KEC2']['70'] }}</label>
                                        <hrms-timepicker  v-model="detail.timdstr"
                                                          :disabled="!validateStaappr"
                                                          v-validate="'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timdend|date_format:HH:mm'"
                                                          data-vv-value-path="inputTime"
                                                          name="timdstr"
                                                          :has-error="errors.has('timdstr')" />
                                        <div class="text-error" v-show="errors.has('timdstr')">{{errors.first('timdstr')}}</div>
                                    </div>

                                    <div class="col-xs-6">
                                        <label>&nbsp;</label>
                                        <span class="pull-left" style="margin-top:30px; margin-left:-15px; ">-</span>
                                        <hrms-timepicker  v-model="detail.timdend"
                                                          :disabled="!validateStaappr"
                                                          v-validate="'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timdstr|date_format:HH:mm'"
                                                          data-vv-value-path="inputTime"
                                                          name="timdend"
                                                          :has-error="errors.has('timdend')" />
                                        <div class="text-error" v-show="errors.has('timdend')">{{errors.first('timdend')}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--   After Time Work   -->
                        <div class="col-md-12">
                            <div class="form-group clearfix">
                                <div class="row">
                                    <div class="col-xs-6">
                                        <label>{{ labels['HRES6KEC2']['80'] }}</label>
                                        <hrms-timepicker  v-model="detail.timastr"
                                                          :disabled="!validateStaappr"
                                                          v-validate="'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timaend|date_format:HH:mm'"
                                                          data-vv-value-path="inputTime"
                                                          name="timastr"
                                                          :has-error="errors.has('timastr')" />
                                        <div class="text-error" v-show="errors.has('timastr')">{{errors.first('timastr')}}</div>
                                    </div>

                                    <div class="col-xs-6">
                                        <label>&nbsp;</label>
                                        <span class="pull-left" style="margin-top:30px; margin-left:-15px; ">-</span>
                                        <hrms-timepicker  v-model="detail.timaend"
                                                          :disabled="!validateStaappr"
                                                          v-validate="'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timastr|date_format:HH:mm'"
                                                          data-vv-value-path="inputTime"
                                                          name="timaend"
                                                          :has-error="errors.has('timaend')" />
                                        <div class="text-error" v-show="errors.has('timaend')">{{errors.first('timaend')}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            </div>

            <div class="col-xs-12 col-md-6 col-lg-5">
              <div class="row">
                <!--   Remark of O.T Req.   -->
                <div class="col-xs-12 panel-codrem">
                  <div class="form-group clearfix">
                      <label>{{ labels['HRES6KEC2']['90'] }} <span class="red">*</span></label>
                      <hrms-dropdown  v-model="detail.codrem"
                                      :options="arrCodrem[nowLang]"
                                      :disabled="!validateStaappr"
                                      v-validate="'required'"
                                      data-vv-value-path="inputValue"
                                      data-vv-name="codrem"
                                      :has-error="errors.has('codrem')" />
                      <div class="text-error" v-show="errors.has('codrem')">{{errors.first('codrem')}}</div>
                  </div>
                </div>

                <!--   Description of O.T Req.   -->
                <div class="col-xs-12 panel-remark">
                    <div class="form-group clearfix">
                        <label>{{ labels['HRES6KEC2']['95'] }} <span class="red">*</span></label>
                        <textarea v-validate="'required|max:200'"
                                  v-model="detail.remark"
                                  name="remark"
                                  maxlength="200"
                                  :class="{ 'form-control' : true, 'input-error' : errors.has('remark') }"
                                  :disabled="!validateStaappr"></textarea>
                        <div class="text-error" v-show="errors.has('remark')">{{errors.first('remark')}}</div>
                        <div class="remark-limit-character">{{ dispLimitLabel(200) }}</div>
                    </div>
                </div>
              </div>
            </div>
          </form>
        </div>
    </div>

      <div class="box-footer">
          <!-- Sumit Button -->
          <button type="button" class="btn bg-dark-gray" @click="callBack()" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
          <button type="button" class="btn bg-color-skin" @click="callSave()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { constLabels } from 'assets/js/constLabels.js'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres6ke-detail',
  props: [ 'labels', 'labelsButton', 'detail', 'currentDtereq', 'currentNumseq', 'currentCodempid', 'nowLang', 'toggle', 'postHres6keSave', 'indexSelected', 'arrCodrem', 'descCodapp', 'searchParams', 'receivedHres6keIndex' ],
  computed: {
    validateStaappr () {
      return (this.detail.staappr !== 'A' && this.detail.staappr !== 'Y' && this.detail.staappr !== 'N')
    }
  },
  created () {
    if (typeof this.arrCodrem[this.nowLang][this.detail.codrem] === 'undefined') {
      this.detail.codrem = ''
    }
  },
  mount () {
    this.errors.clear()
  },
  watch: {
    'detail.dtestrt' () {
      this.$validator.validate('dteend', this.detail.dteend).catch(e => {})
    },
    'detail.dteend' () {
      this.$validator.validate('dtestrt', this.detail.dtestrt).catch(e => {})
    },
    'detail.remark' () {
      this.$validator.validate('remark', this.detail.remark).catch(e => {})
    },
    'detail.timbstr' () {
      this.validateRequiredTime('timbend')
    },
    'detail.timbend' () {
      this.validateRequiredTime('timbstr')
    },
    'detail.timdstr' () {
      this.validateRequiredTime('timdend')
    },
    'detail.timdend' () {
      this.validateRequiredTime('timdstr')
    },
    'detail.timastr' () {
      this.validateRequiredTime('timaend')
    },
    'detail.timaend' () {
      this.validateRequiredTime('timastr')
    },
    detail () {
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    validateRequiredTime (requiredWhenExistField) {
      this.$validator.validate(requiredWhenExistField, this.detail[requiredWhenExistField]).catch(e => {})
      // const requiredAnyFields = ['timbstr', 'timbend', 'timdstr', 'timdend', 'timastr', 'timaend']
      // for (let requiredAnyField of requiredAnyFields) {
      //   this.$validator.validate(requiredAnyField, this.detail[requiredAnyField], { name: 'requiredAny', params: requiredAnyFields }).catch(e => {})
      // }
    },
    saveParams () {
      return {
        codempid: this.currentCodempid,
        numseq: '' + this.currentNumseq,
        dtereq: this.currentDtereq,
        staappr: this.detail.staappr,
        routeno: this.detail.routeno,
        dtestrt: this.detail.dtestrt,
        dteend: this.detail.dteend,
        timbstr: this.detail.timbstr.replace(':', ''),
        timbend: this.detail.timbend.replace(':', ''),
        timdstr: this.detail.timdstr.replace(':', ''),
        timdend: this.detail.timdend.replace(':', ''),
        timastr: this.detail.timastr.replace(':', ''),
        timaend: this.detail.timaend.replace(':', ''),
        codrem: this.detail.codrem,
        remark: this.detail.remark
      }
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHres6keSave({ saveParams: this.saveParams(), searchParams: this.searchParams })
        }
      })
    },
    callBack () {
      this.receivedHres6keIndex(this.searchParams)
      this.toggle('index')
    }
  }
}
</script>

<style src="./style.scss" lang='scss'></style>



// WEBPACK FOOTER //
// detail.vue?223f5b66